// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__g4d8j"};